import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { affiliates } from '../../data/CarouselData';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        slidesToSlide: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1,
    },
};
const CarouselComponent = () => {
    return (
        <div className=" md:w-4/5 mx-auto py-20">
            <Carousel
                additionalTransfrom={0}
                autoPlaySpeed={3000}
                // centerMode={false}
                className=""
                containerClass="container container_slider w-full"
                // dotListClass=""
                draggable
                autoPlay={true}
                focusOnSelect={false}
                infinite={true}
                itemClass=""
                // transitionDuration={500}
                // keyBoardControl
                // minimumTouchDrag={80}
                // removeArrowOnDeviceType={["tablet", "mobile"]}
                // dotListClass="custom-dot-list-style"
                // itemClass="carousel-item-padding-40-px"
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive}
                rewind={true}
                // rewindWithAnimation={true}
                // rtl={false}
                arrows={false}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
            {affiliates?.map((item, idx) => {
    return (
        <div key={idx}>
            <h2 className='font-bold text-[#121212] text-[4rem] md:text-[3rem] smallScreens:text-[3rem] text-center mb-20'>
                {item?.title}
            </h2>
            <div className="flex justify-center flex-wrap gap-4 mt-6">
                {item?.images?.map((img, i) => {
                    return (
                        <div
                            key={i}
                            className="flex items-center justify-center py-2 w-[200px] h-[80px] border border-gray-300 rounded-2xl shadow-sm"
                        >
                            <img
                                className="object-contain w-44 h-full"
                                src={img}
                                alt={`Affiliate ${i}`}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
})}

            </Carousel>
        </div>
    );
};

export default CarouselComponent;

